export const StrokeS = "1px";
export const StrokeM = "2px";
export const StrokeL = "3px";
export const StrokeXl = "4px";
